import { VendorBillCreate } from './VendorBillCreate';
import { VendorBillList } from './VendorBillList';
import { VendorBillShow } from './VendorBillShow';

export const vendor_bills = {
    list: VendorBillList,
    create: VendorBillCreate,
    show: VendorBillShow,
};
